import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { Image } from '@/features/shared/elements/Image/NextImage'

type Props = {
  src: string
}

export const BlogPostImage = ({ src }: Props) => (
  <ImageWrapper>
    <Image src={src} alt="" fill style={{ objectFit: 'cover' }} sizes="700px" preload />
  </ImageWrapper>
)

const ImageWrapper = styled.div`
  position: relative;
  height: 225px;
  width: 100%;
  overflow-y: hidden;
  margin-bottom: 1.5rem;

  @media ${screenSizes.tablet} {
    height: 350px;
  }
`
